import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import notificationApi from "../../services/notification.api";
import { AdminNotification } from "@/types/notification.definition";
import {
  deleteNotificationFailure,
  deleteNotificationRequest,
  deleteNotificationSuccess,
  fetchNotificationsFailure,
  fetchNotificationsRequest,
  fetchNotificationsSuccess,
  markAllNotificationsReadFailure,
  markAllNotificationsReadRequest,
  markAllNotificationsReadSuccess,
  markNotificationReadFailure,
  markNotificationReadRequest,
  markNotificationReadSuccess,
} from "../reducers/notificationSlice";

function* fetchNotifications() {
  try {
    const notifications: AdminNotification[] = yield call(
      notificationApi.getNotifications
    );
    yield put(fetchNotificationsSuccess(notifications));
  } catch (error) {
    yield put(
      fetchNotificationsFailure(
        error instanceof Error ? error.message : "Failed to fetch notifications"
      )
    );
  }
}

function* markNotificationRead(action: {
  payload: { id: number };
  type: string;
}) {
  try {
    yield call(notificationApi.markAsRead, action.payload.id);
    yield put(markNotificationReadSuccess(action.payload.id));
  } catch (error) {
    yield put(
      markNotificationReadFailure(
        error instanceof Error
          ? error.message
          : "Failed to mark the notification as read"
      )
    );
  }
}

function* markAllNotificationsRead() {
  try {
    yield call(notificationApi.markAllAsRead);
    yield put(markAllNotificationsReadSuccess());
  } catch (error) {
    yield put(
      markAllNotificationsReadFailure(
        error instanceof Error
          ? error.message
          : "Failed to mark every notification as read"
      )
    );
  }
}

function* removeNotification(action: {
  payload: { id: number };
  type: string;
}) {
  try {
    yield call(notificationApi.deleteNotification, action.payload.id);
    yield put(deleteNotificationSuccess(action.payload.id));
  } catch (error) {
    yield put(
      deleteNotificationFailure(
        error instanceof Error
          ? error.message
          : "Failed to delete the notification"
      )
    );
  }
}

export function* notificationSaga() {
  yield takeLatest(fetchNotificationsRequest, fetchNotifications);
  yield takeEvery(markNotificationReadRequest, markNotificationRead);
  yield takeLatest(markAllNotificationsReadRequest, markAllNotificationsRead);
  yield takeEvery(deleteNotificationRequest, removeNotification);
}
